<template>
  <div
    class="evaluation-answer"
    v-if="question.$answers.length"
  >
    <!-- VERDADERO / FALSO -->

    <div class="answer-item">
      <evaluation-answer-true-false
        v-if="question.type==='true_or_false'"
        :branch-type="branchType"
        :question="question"
        :disabled="disabled"
      />
    </div>

    <!-- OPCIÓN MÚLTIPLE -->
    <evaluation-answer-multiple
      v-if="question.type==='multiple'"
      :branch-type="branchType"
      :question="question"
      :disabled="disabled"
    />

    <!-- OPCIÓN ÚNICA -->
    <evaluation-answer-unique
      v-if="question.type==='unique'"
      :branch-type="branchType"
      :question="question"
      :disabled="disabled"
    />

    <!-- RANGO DE OPCIONES-->
    <div
      class="answer-item"
      v-if="question.type==='range_options'"
    >
      <evaluation-answer-slider
        :branch-type="branchType"
        :question="question"
        :disabled="disabled"
      />
    </div>
    <!-- RANGO -->
    <div
      class="answer-item"
      v-if="question.type==='range'"
    >
      <evaluation-answer-range
        :branch-type="branchType"
        :question="question"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import EvaluationAnswerRange from '@/modules/evaluation/components/answers/evaluation-answer-range'
import EvaluationAnswerSlider from '@/modules/evaluation/components/answers/evaluation-answer-slider'
import EvaluationAnswerTrueFalse from '@/modules/evaluation/components/answers/evaluation-answer-true-false'
import EvaluationAnswerMultiple from '@/modules/evaluation/components/answers/evaluation-answer-multiple'
import EvaluationAnswerUnique from '@/modules/evaluation/components/answers/evaluation-answer-unique'

export default {
  name: 'EvaluationAnswer',
  components: {
    EvaluationAnswerUnique,
    EvaluationAnswerMultiple,
    EvaluationAnswerTrueFalse,
    EvaluationAnswerSlider,
    EvaluationAnswerRange
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    branchType: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-answer {
  .answer-item {
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-answer.vue